import { createContext, useContext, useState } from 'react';

const DashboardContext = createContext();

export function DashboardProvider({ children }) {
    const [webDashboardId, setWebDashboardId] = useState(null);

    return (
        <DashboardContext.Provider value={{ webDashboardId, setWebDashboardId }}>
            {children}
        </DashboardContext.Provider>
    );
}

export function useDashboardContext() {
    return useContext(DashboardContext);
}
